import cls from "@fvilers/cls";
import { useState } from "react";
import styles from "./AnimatedValue.module.css";

type AnimatedValueProps = {
  className?: string;
  value: number | undefined;
};

export function AnimatedValue({ className, value }: AnimatedValueProps) {
  const [prevValue, setPrevValue] = useState<number | null>(null);
  const [displayValue, setDisplayValue] = useState(value);
  const [direction, setDirection] = useState<"down" | "up">("up");

  if (value !== displayValue && (!value || !isNaN(value))) {
    if (!value || !displayValue) {
      setDirection("up");
    } else {
      setDirection(value > displayValue ? "up" : "down");
    }
    setPrevValue(displayValue ?? null);
    setDisplayValue(value);
  }

  return (
    <div className={cls(styles.AnimatedValue, className)}>
      {prevValue !== null && (
        <span
          className={cls(styles.Value, styles.exit, styles[direction])}
          onAnimationEnd={() => {
            setPrevValue(null);
          }}
        >
          {prevValue}
        </span>
      )}
      <span
        className={cls(
          styles.Value,
          prevValue !== null && styles.enter,
          styles[direction],
        )}
      >
        {value}
      </span>
    </div>
  );
}
